import React from 'react';
import { View } from 'react-native-web';
export function GestureHandlerRootView({ children, style }) {
  return <View style={style}>{children}</View>;
}
